import React, {useState, useEffect} from "react";
import {Button, Card, CardBody, CardFooter, Typography, IconButton} from "@material-tailwind/react";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import Footer from "./footer";
import {CheckCircle} from "lucide-react";

function Complete() {
    const navigate = useNavigate();
    const [branch, setBranch] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const getAddress = async () => {
        //localStorage.clear();
        try {
            await axios
                .get(process.env.REACT_APP_API_URL + "/api/v1/getAddress", {
                    withCredentials: true,
                })
                .then((response) => {
                    setBranch(response.data);
                })
                .catch((error) => {
                    console.log(error);
                    navigate("/");
                });
        } catch (e) {
            console.log(e);
        }

        document.cookie = `Authorization=;expires=;path=`; //얘약하고 하면 쿠키 자동 삭제. 다시 예약 시도하지 못하도록 막음.
    };

    useEffect(() => {
        getAddress();
    }, []);

    const handleClick = () => {
        navigate("/");
    };

    return (
        <>
            <div className="min-h-screen bg-gradient-to-br from-green-50 to-gray-50">
                <div className="container mx-auto max-w-7xl px-4 py-4 sm:py-6">
                    {/* Enhanced Header */}
                    <div className="mb-6 sm:mb-8">
                        <div className="flex items-center justify-center mb-4 sm:mb-6">
                            <div>
                                <Typography variant="h4" color="blue-gray"
                                            className="font-bold text-xl sm:text-2xl lg:text-3xl text-center">
                                    Reservation Complete
                                </Typography>
                                <Typography variant="paragraph" color="gray" className="mt-1 text-sm sm:text-base text-center">
                                    Your booking has been successfully confirmed
                                </Typography>
                            </div>
                        </div>

                        {/* Progress indicator */}
                        <div className="flex items-center justify-center mb-6 sm:mb-8 overflow-x-auto px-2 sm:px-4 overflow-y-hidden">
                            <div className="flex items-center justify-center w-full max-w-3xl">
                                {/* Step 1 - Select Services */}
                                <div className="flex items-center min-w-max justify-center">
                                    <div className="flex items-center">
                                        <div
                                            className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0"
                                        >
                                            <CheckCircle className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5"/>
                                        </div>
                                        <Typography variant="small"
                                                    className="ml-1 sm:ml-2 text-green-600 text-xs sm:text-sm whitespace-nowrap hidden sm:block font-medium">
                                            1. Services
                                        </Typography>
                                    </div>
                                </div>

                                {/* Connector line 1 */}
                                <div className="w-4 sm:w-12 md:w-16 h-0.5 bg-green-500 mx-1 sm:mx-2 flex-shrink-0"></div>

                                {/* Step 2 - Choose Schedule */}
                                <div className="flex items-center min-w-max justify-center">
                                    <div className="flex items-center">
                                        <div
                                            className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0"
                                        >
                                            <CheckCircle className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5"/>
                                        </div>
                                        <Typography variant="small"
                                                    className="ml-1 sm:ml-2 text-green-600 text-xs sm:text-sm whitespace-nowrap hidden sm:block font-medium">
                                            2. Schedule
                                        </Typography>
                                    </div>
                                </div>

                                {/* Connector line 2 */}
                                <div className="w-4 sm:w-12 md:w-16 h-0.5 bg-green-500 mx-1 sm:mx-2 flex-shrink-0"></div>

                                {/* Step 3 - Car Information */}
                                <div className="flex items-center min-w-max justify-center">
                                    <div className="flex items-center">
                                        <div
                                            className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0"
                                        >
                                            <CheckCircle className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5"/>
                                        </div>
                                        <Typography variant="small"
                                                    className="ml-1 sm:ml-2 text-green-600 text-xs sm:text-sm whitespace-nowrap hidden sm:block font-medium">
                                            3. Car
                                        </Typography>
                                    </div>
                                </div>

                                {/* Connector line 3 */}
                                <div className="w-4 sm:w-12 md:w-16 h-0.5 bg-green-500 mx-1 sm:mx-2 flex-shrink-0"></div>

                                {/* Step 4 - Contact Information */}
                                <div className="flex items-center min-w-max justify-center">
                                    <div className="flex items-center">
                                        <div
                                            className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0"
                                        >
                                            <CheckCircle className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5"/>
                                        </div>
                                        <Typography variant="small"
                                                    className="ml-1 sm:ml-2 text-green-600 text-xs sm:text-sm whitespace-nowrap hidden sm:block font-medium">
                                            4. Contact
                                        </Typography>
                                    </div>
                                </div>

                                {/* Connector line 4 */}
                                <div className="w-4 sm:w-12 md:w-16 h-0.5 bg-green-500 mx-1 sm:mx-2 flex-shrink-0"></div>

                                {/* Step 5 - Complete (CURRENT) */}
                                <div className="flex items-center min-w-max relative justify-center">
                                    <div className="relative">
                                        {/* Pulsing ring animation */}
                                        <div className="absolute inset-0 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-green-500 rounded-full animate-ping opacity-20 hidden sm:block"></div>
                                        <div className="absolute inset-0 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-green-500 rounded-full animate-pulse opacity-30 hidden sm:block"></div>

                                        {/* Main step indicator */}
                                        <div className="relative w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-gradient-to-br from-green-500 to-green-600 text-white rounded-full flex items-center justify-center text-sm sm:text-base md:text-lg font-bold shadow-lg border-2 sm:border-4 border-white flex-shrink-0 z-10">
                                            <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6"/>
                                        </div>
                                    </div>

                                    {/* Current step indicator */}
                                    <div className="ml-2 sm:ml-3 hidden sm:block">
                                        <Typography variant="small"
                                                    className="font-bold text-green-600 text-sm sm:text-base whitespace-nowrap">
                                            Complete
                                        </Typography>
                                        <div className="text-xs text-green-500 font-medium">
                                            Finished
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-center">
                        <div className="w-full max-w-2xl">
                            <Card className="border-0 shadow-xl bg-white/80 backdrop-blur-sm">
                                <CardBody className="p-6 sm:p-8 lg:p-10">
                                    <div className="flex flex-col items-center text-center">
                                        {/* Success Icon */}
                                        <div className="mb-6 sm:mb-8">
                                            <div className="relative">
                                                {/* Outer glow effect */}
                                                <div className="absolute inset-0 w-20 h-20 sm:w-24 sm:h-24 bg-green-200 rounded-full animate-pulse opacity-50"></div>
                                                <div className="absolute inset-0 w-20 h-20 sm:w-24 sm:h-24 bg-green-300 rounded-full animate-ping opacity-30"></div>

                                                {/* Main success icon */}
                                                <div className="relative w-20 h-20 sm:w-24 sm:h-24 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center shadow-lg z-10">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="48"
                                                        height="48"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="3"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        className="text-white w-10 h-10 sm:w-12 sm:h-12"
                                                    >
                                                        <path d="M20 6 9 17l-5-5"></path>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Success Message */}
                                        <div className="mb-8 sm:mb-10">
                                            <Typography variant="h3" className="font-bold text-green-600 mb-4">
                                                Reservation Complete!
                                            </Typography>
                                            <Typography variant="h6" color="blue-gray" className="font-semibold mb-2">
                                                Thank you for your booking
                                            </Typography>
                                            <Typography variant="paragraph" color="gray" className="text-sm sm:text-base max-w-md mx-auto">
                                                Your reservation has been successfully confirmed. You will receive a confirmation email shortly.
                                            </Typography>
                                        </div>

                                        {/* Important Information */}
                                        <div className="w-full bg-gray-50 rounded-xl p-4 sm:p-6 mb-6 sm:mb-8 border border-gray-200">
                                            <Typography variant="h6" color="blue-gray" className="font-semibold mb-4 text-center">
                                                Important Information
                                            </Typography>

                                            <div className="space-y-3 text-left">
                                                <Typography className="font-medium text-gray-700 text-sm sm:text-base">
                                                    📅 예약 변경을 원하시면 최소 1일 전에 연락 주시기 바랍니다.
                                                </Typography>
                                                <Typography className="font-medium text-gray-700 text-sm sm:text-base">
                                                    📞 If you wish to change or cancel your reservation, please contact us at least 1 day in advance.
                                                </Typography>
                                            </div>
                                        </div>

                                        {/* Contact Information */}
                                        {branch && (
                                            <div className="w-full bg-blue-50 rounded-xl p-4 sm:p-6 mb-6 sm:mb-8 border border-blue-200">
                                                <Typography variant="h6" color="blue-gray" className="font-semibold mb-4 text-center">
                                                    Contact Information
                                                </Typography>
                                                <div className="space-y-2">
                                                    <Typography variant="small" className="text-blue-gray-800 font-medium text-center">
                                                        📍 {branch?.address}
                                                    </Typography>
                                                    <Typography variant="small" className="text-blue-gray-800 font-medium text-center">
                                                        📞 {branch?.phone}
                                                    </Typography>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </CardBody>
                                <CardFooter className="pt-0 pb-6 sm:pb-8">
                                    <div className="text-center">
                                        <Button
                                            onClick={handleClick}
                                            variant="gradient"
                                            color="green"
                                            size="lg"
                                            className="w-full sm:w-auto px-8 py-3 text-base font-semibold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                                        >
                                            Return to Home
                                        </Button>
                                    </div>
                                </CardFooter>
                            </Card>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        </>
    );
}

export default Complete;
